(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-subscription-form-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    class SubscriptionFormPicker extends HTMLElement {
      static cache = new Map();
      static inFlight = new Map();

      connectedCallback() {
        this.onPrefetchEvent = this.onPrefetchEvent.bind(this);
        this.onChange = this.onChange.bind(this);

        // Prefetch triggers
        ['pointerenter', 'pointerdown', 'focusin'].forEach((type) => {
          this.addEventListener(
            type,
            this.onPrefetchEvent,
            type === 'pointerenter' ? { capture: true } : undefined
          );
        });

        // Change handler
        this.addEventListener('change', this.onChange);
      }

      getSelectFromEvent(event) {
        const select = event.target.closest('[data-subscription-variant-select]');
        if (!select || !this.contains(select)) return null;
        return select;
      }

      buildSectionRenderUrl(variantUrl) {
        if (!variantUrl) return null;
        const url = new URL(variantUrl, window.location.origin);
        url.searchParams.set('section_id', 'custom-product-card-dynamic');
        return url.toString();
      }

      async fetchSection(url) {
        if (this.constructor.cache.has(url)) return this.constructor.cache.get(url);
        if (this.constructor.inFlight.has(url)) return this.constructor.inFlight.get(url);

        const promise = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((response) => response.text())
          .then((responseText) => {
            this.constructor.cache.set(url, responseText);
            this.constructor.inFlight.delete(url);
            return responseText;
          })
          .catch((error) => {
            this.constructor.inFlight.delete(url);
            throw error;
          });

        this.constructor.inFlight.set(url, promise);
        return promise;
      }

      replaceCardFromResponse(select, responseText) {
        const parser = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceCard = parser.querySelector('.product-card');
        const destinationCard = select.closest('.product-card');

        if (!sourceCard || !destinationCard) return;
        destinationCard.replaceWith(sourceCard);
      }

      updateSellingPlanField(select) {
        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        const sellingPlanInput = select.form?.elements?.['selling_plan'];
        if (sellingPlanInput) {
          sellingPlanInput.value = selectedOption.dataset.sellingPlanId || '';
        }
      }

      prefetchAllVariantCards(select) {
        if (select.dataset.prefetched === 'true') return;
        select.dataset.prefetched = 'true';

        Array.from(select.options).forEach((option) => {
          const url = this.buildSectionRenderUrl(option.dataset.variantUrl);
          if (!url) return;
          this.fetchSection(url).catch(() => {});
        });
      }

      onPrefetchEvent(event) {
        const select = this.getSelectFromEvent(event);
        if (!select) return;
        this.prefetchAllVariantCards(select);
      }

      async onSelectorChange(select) {
        this.updateSellingPlanField(select);

        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        const url = this.buildSectionRenderUrl(selectedOption.dataset.variantUrl);
        if (!url) return;

        select.setAttribute('aria-busy', 'true');

        try {
          const responseText = await this.fetchSection(url);
          this.replaceCardFromResponse(select, responseText);
        } catch (error) {
          console.error(error);
        } finally {
          select.removeAttribute('aria-busy');
        }
      }

      onChange(event) {
        const select = this.getSelectFromEvent(event);
        if (!select) return;
        this.onSelectorChange(select);
      }
    }

    customElements.define('subscription-form-picker', SubscriptionFormPicker);

  })();
  } catch(e) { console.error(e); }
})();

})();
